/**
 * This is auto-generated code. DO NOT EDIT IT!!
 * Any manual change on this file will disappear on
 * next code generation
 */
import { UserLoginType } from './enums';
import { Encrypt } from './base.models';

export class UserNormalLoginRequest {
	public _type: UserLoginType;
	@Encrypt()
	public password: string;
	public name: string;

	constructor(values: UserNormalLoginRequest) {
		for (const [key, value] of Object.entries(values)) this[key] = value;
	}
}
